import { render, staticRenderFns } from "./options.vue?vue&type=template&id=d2478122&scoped=true&"
import script from "./options.vue?vue&type=script&lang=js&"
export * from "./options.vue?vue&type=script&lang=js&"
import style0 from "./options.vue?vue&type=style&index=0&id=d2478122&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2478122",
  null
  
)

export default component.exports